<template>
  <div class="children-planning">
    <div class="row">
      <div class="col-sm-3">
        <h3 style="margin-top: 4px;">
          {{ this.$moment(dateStart).format('MMMM') }}
          <span v-if="$moment(dateStart).format('YYYY') !== $moment().format('YYYY')">
            {{ $moment(dateStart).format('YYYY') }}
          </span>
        </h3>
      </div>
      <div class="col-sm-9 text-end">
        <date-range-select
          type="month"
          @changeDateRange="getSchedules(selectedChild, $event.dateStart, $event.dateEnd)"
        ></date-range-select>
      </div>
    </div>
    <div v-if="isLoading">
      <p class="text-center" style="margin: 50px">Laden...</p>
    </div>
    <div v-if="dates && schedules && isLoading === false">
      <div v-bind:key="index" v-for="(date, index) in dates" class="planning-week">
        <div v-if="$moment(date).format('d') === '1'" class="row planning-border-first">
          <div class="col-12 col-sm-3">Week {{ this.$moment(date).format('w') }}</div>
          <div class="col-12 col-sm-3">Groep</div>
          <div class="col-12 col-sm-3">Tijd</div>
        </div>
        <div v-if="getSchedule(date).length > 0">
          <div
            v-bind:key="schedule.id"
            v-for="schedule in getSchedule(date)"
            class="row planning-row"
          >
            <div class="col-12 col-sm-3">
              {{ this.$moment(date).format('dd D MMM') }}
            </div>
            <div class="col-12 col-sm-3">
              {{ schedule.group.name|| 'Geen groep naam' }}
            </div>
            <div class="col-12 col-sm-3">
              <div :class="{
                'planning-row-time': true,
                'deleted': (schedule.status && schedule.status === 'DELETED')
              }">
                <span>{{ $moment(schedule.date + ' ' + schedule.start_time).format('HH:mm') }}</span>
                -
                <span>&nbsp;{{ $moment(schedule.date + ' ' + schedule.end_time).format('HH:mm') }}</span>
              </div>
            </div>
            <div class="col-12 col-sm-3">
              <span v-on:click="showModalPlanningAction(selectedChild.id, schedule.group.id, schedule.date)">
                <icon
                  v-if="getApplicationSetting('ipad_edit_planning') === '1'"
                  name="edit"
                  :fontSize="'1.5em'"
                />
              </span>
            </div>
          </div>
        </div>
        <div v-else class="row planning-row">
          <div class="col-12 col-sm-3">
            {{ this.$moment(date).format('dd D MMM') }}
          </div>
          <div class="col-12 col-sm-3"></div>
          <div class="col-12 col-sm-3"></div>
          <div class="col-12 col-sm-3">
            <span v-on:click="showModalPlanningAction(selectedChild.id, getOneSelectedGroupId(), date)">
              <icon
                  v-if="getApplicationSetting('ipad_edit_planning') === '1'"
                  name="add"
                  :fontSize="'1.5em'"
              />
            </span>
          </div>
        </div>
      </div>
    </div>
    <modal v-if="showModalPlanning">
      <template v-slot:header>
        <h3 class="modal-title">
          {{modalTitle}}
        </h3>
          <button
            class="btn-close"
            type="button"
            v-on:click="closeModalPlanningAction()"
          ></button>
      </template>
      <template v-slot:body>
        <div id="calendarDialog" class="dialog-child-planning" style="padding: 20px">
          <kidsadmin-agenda-dialog
            :idChild="modalSelect.idChild"
            :idGroup="modalSelect.idGroup"
            :date="modalSelect.date"
            :agendaDialogsessionToken="session.session_token"
            :agendaDialogDeviceToken="deviceToken"
            :agendaDialogApi="apiUrl"
            :agendaDialogApiV3="apiUrlV3"
          />
        </div>
      </template>
      <template v-slot:footer>
        <div>
          <button
            type="button"
            class="btn btn-outline-info"
            v-on:click="closeModalPlanningAction()"
          >Sluiten</button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import icon from "@/components/Icon";
import DateRangeSelect from "@/components/Date-Range-Select";
import Modal from "@/components/Modal";
import KidsadminAgendaDialog from "@novict/kidsadmin-agenda-dialog";
import "@novict/kidsadmin-agenda-dialog/dist/kidsadmin-agenda-dialog.css";
export default {
  name: "children-planning",
  components: {
    DateRangeSelect,
    icon,
    Modal,
    KidsadminAgendaDialog
  },
  computed: {
    deviceToken() {
      return this.$store.getters.deviceToken;
    },
    session() {
      return this.$store.getters.session;
    },
    selectedGroup() {
      return this.$store.getters.selectedGroup;
    }
  },
  data() {
    return {
      isLoading: false,
      child: null,
      schedules: null,
      dateStart: null,
      dateEnd: null,
      dates: null,
      showModalPlanning: false,
      modalTitle: "",
      modalSelect: {
        idChild: 0,
        idGroup: 0,
        date: '',
      },
      apiUrl: process.env.VUE_APP_API_URL,
      apiUrlV3: process.env.VUE_APP_API_V3_URL
    };
  },
  created() {
    this.dateStart = this.$moment()
      .startOf("month")
      .format("YYYY-MM-DD");
    this.dateEnd = this.$moment()
      .endOf("month")
      .format("YYYY-MM-DD");
    this.getSchedules(this.selectedChild, this.dateStart, this.dateEnd);
  },
  methods: {
    closeModalPlanningAction() {
      this.showModalPlanning = false;
      this.modalTitle = "";
      this.getSchedules(this.selectedChild, this.dateStart, this.dateEnd);
    },
    showModalPlanningAction(idChild, idGroup, date) {
      this.showModalPlanning = true;
      this.modalSelect = {
        idChild: idChild,
        idGroup: idGroup,
        date: date,
      },
      this.$request.post(process.env.VUE_APP_API_URL + "/ChildPlanning/gettitle", {
          ...this.$request.getDeprecatedBodyAuthentication(),
          idChild: this.child.id,
          date: date
        })
        .then(data => {
          this.modalTitle = "Planning " +
            data.child.name +
            " op " +
            this.$moment(data.date).format("DD-MM-YYYY");
        });
    },
    getDates(startDate, endDate) {
      startDate = this.$moment(startDate).startOf("isoweek");
      endDate = this.$moment(endDate).endOf("isoweek");
      var now = startDate.clone();
      var dates = [];
      while (now.isBefore(endDate) || now.isSame(endDate)) {
        dates.push(now.format("YYYY-MM-DD"));
        now.add(1, "days");
      }
      this.dates = dates;
    },
    getSchedule(date) {
      return this.$lodash().filter(this.schedules, function(schedule) {
        return schedule.date === date;
      });
    },
    getSchedules(child, dateStart, dateEnd) {
      this.child = child || this.selectedChild;
      this.dateStart = dateStart || this.dateStart;
      this.dateEnd = dateEnd || this.dateEnd;
      this.getDates(this.dateStart, this.dateEnd);
      dateStart = this.$moment(dateStart)
        .startOf("isoweek")
        .format("YYYY-MM-DD");
      dateEnd = this.$moment(dateEnd)
        .endOf("isoweek")
        .format("YYYY-MM-DD");
      this.isLoading = true;
      this.$request.get('/planning?id_child=' + this.child.id + '&date=' + dateStart + '&up_to_date=' + dateEnd)
      .then(response => {
        this.isLoading = false;
        if (response.data) {
          this.schedules = response.data;
        }
      })
    }
  }
};
</script>

<style scoped>
.planning-border-first {
  border-bottom: 1px solid #c3cad4;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-left: 0;
  margin-right: 0;
  color: #c3cad4;
}
.planning-row-time {
  background: rgb(142, 112, 211);
  border: 2px solid rgb(118, 92, 174);
  border-radius: 20px;
  color: white;
  text-align: center;
  cursor: pointer;
}
.planning-row-time.deleted {
  background-color: rgb(150,150,150);
  border: 2px solid rgb(125,125,125);
}
.planning-row {
  padding: 10px;
  margin-left: 0px;
  margin-right: 0px;
  border: 1px solid #c3cad4;
  border-width: 0px 1px 1px 1px;
}
</style>
